import { ReactNode, FC, InputHTMLAttributes } from 'react'
import * as styles from 'styles/atoms/inputs/Checkbox.css'
import { QAMarked } from 'interfaces/component'
import { Omit } from 'interfaces'
import * as cn from 'classnames'
import { AnyRegisterType } from 'interfaces/form'

export type LabelCheckboxProps = {
  label?: ReactNode
  className?: string
  labelClassName?: string
  labelRenderer?: (isChecked: boolean) => ReactNode
}

export type CheckboxProps =
  & QAMarked
  & LabelCheckboxProps
  & Omit<InputHTMLAttributes<HTMLInputElement>, 'className' | 'type' | 'name'>
  & {
    name: string
    type?: 'checkbox' | 'radio'
    labelRenderer?: (isChecked: boolean) => ReactNode
    register?: AnyRegisterType
  }

const Checkbox: FC<CheckboxProps> = (props) => {
  const { register, labelRenderer, label, name, checked, qaMarker, qaType, type = 'checkbox', className, labelClassName, ...restInputProps } = props

  let labelChild: ReactNode | null = null
  if (label) {
    labelChild = label
  } else if (labelRenderer) {
    labelChild = labelRenderer(!!checked)
  }
  const fieldProps = !!name && !!register ? register(name) : { name }

  return (
    <span className={ cn(styles.checkbox, className) }>
      <label
        className={ cn(styles.label, labelClassName) }
        data-qa-type='checkbox-label'
        data-qa-marker={ qaMarker }
        data-qa-value={ checked ? 'checked' : 'unchecked' }
      >
        <input
          className={ styles.input }
          type={ type }
          { ...fieldProps }
          checked={ checked }
          { ...restInputProps }
        />
        <span
          data-qa-type='checkbox-mark'
          className={ styles.mark }
        />
        { labelChild }
      </label>
    </span>
  )
}


export default Checkbox
